export const getArrayBuffer = function(url) {
    return new Promise(function (res, rej) {
        var request = new XMLHttpRequest();
        request.open('GET', url, true);
        request.responseType = 'arraybuffer';
        request.onload = function () {
            var status = request.status;

            if (status >= 200 && status < 300 || status === 304) {
                res(request.response);
            } else {
                rej(request.statusText);
            }
        };
        request.onerror = function (e) {
            rej(request.statusText);
            console.error(request.statusText);
        };
        request.send();
    })
}
